// * GET =====================================
export const OUTPUT_SETTINGS_GET_RECORD = `/output_settings/record`;

export const OUTPUT_SETTINGS_GET_DEFAULT_OUTPUT_SETTINGS = `/output_settings/default_output_settings`;

// * PATCH ===================================

// * POST ====================================
export const OUTPUT_SETTINGS_POST_SAVE = `/output_settings/save`;

export const OUTPUT_SETTINGS_POST_SAVE_OUTPUT_SETTINGS_STATE = `/output_settings/save_output_settings_state`;

export const OUTPUT_SETTINGS_POST_ADMIN_LIST = `/output_settings/admin_list`;

export const OUTPUT_SETTINGS_POST_ADMIN_UPDATE = `/output_settings/admin_update`;

export const OUTPUT_SETTINGS_POST_ADMIN_COPY = `/output_settings/admin_copy`;

// * DELETE ==================================
export const OUTPUT_SETTINGS_DELETE_ADMIN_DELETE = (outputSettingsId: number) =>
  `/output_settings/admin_delete/${outputSettingsId}`;

// * PUT =====================================
